import * as _ from 'lodash';
import { Tenant } from 'src/app/shared/models/tenant';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog,
} from '@angular/material/legacy-dialog';
import { Form } from 'src/app/shared/models/application/form';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { Subscription } from 'rxjs';

type PreviewForm = { confirmation: string; id: string };
@Component({
  selector: 'preview-application-modal',
  templateUrl: 'preview-application-modal.component.html',
  styleUrls: ['preview-application-modal.component.scss'],
})
export class PreviewApplicationModalComponent implements OnInit, OnDestroy {
  //a type-safe way to open this modal component
  static open = (dialog: MatLegacyDialog, previewForm: PreviewForm, isSurvey: boolean = false) => {
    dialog.open(PreviewApplicationModalComponent, {
      autoFocus: false,
      data: {
        previewForm: previewForm,
        isSurvey: isSurvey,
      },
    });
  };
  public form: PreviewForm;
  public tenant: Tenant;
  public isApplicationSubmitted: boolean;
  private subscription: Subscription;
  logoUrl: string;
  isSurvey: boolean = false;

  constructor(
    private appConfigService: AppConfigService,
    private workspaceService: WorkspaceService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = data.previewForm;
    this.isApplicationSubmitted = false;
    if (data.isSurvey) {
      this.isSurvey = data.isSurvey;
    }
  }

  ngOnInit(): void {
    this.tenant = this.appConfigService.tenant;

    this.subscription = this.workspaceService.activeWorkspaceLogoUrl.subscribe((result) => {
      if (result) {
        this.logoUrl = result;
      } else {
        this.logoUrl = this.tenant.logoUrl;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  submitApplication = () => {
    this.isApplicationSubmitted = true;
  };
}
